/* eslint react/no-unused-prop-types:0 */

import React from 'react';
import i18n from 'app/common/lib/i18n';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyButton from 'app/common/react/ui/deprecated/LegacyButton';
import listItemsAnd from 'app/common/lib/react/concatList';
import PropTypes from 'prop-types';
import templateConst from 'app/common/lib/templateConst';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';

const BLOCK_URL = templateConst.settings.HELP_BLOCKING + '?source=block_dialogue';

export function getUserNames(arrayOfUsers) {
  return arrayOfUsers.map((user) => <span key={user.id}>{user.full_name}</span>);
}

/**
 * Component that displays list of users to block and option to cancel or submit.
 * Implementation of submit handler is passed in as a prop.
 */
export function UserBlock({ users, onClose, isLoading, onSubmit }) {
  const userNames = <strong key="userlist">{listItemsAnd(getUserNames(users))}</strong>;

  // TODO (tuanhuynh) get rid of br tags
  return (
    <form className="standardForm" method="post">
      <h1>
        {i18n.ngettext(
          'Block this person?',
          'Block these people?',
          users.length,
          'Confirmation text when blocking users (plural)',
        )}
      </h1>
      <p>
        {interpolateNamedTemplate(
          i18n._(
            'If you block {{ users }}, you won’t be able to follow ' +
              ' each other or interact with each other’s Pins.',
            'description of blocking users',
          ),
          { users: userNames },
        )}
        <br />
        <br />
        <a className="external" href={BLOCK_URL}>
          {i18n._('Learn more', 'link to learn more about blocking')}
        </a>
      </p>

      <div className="formFooter">
        <div className="formFooterButtons">
          <LegacyButton
            className="cancelButton"
            id="cancelButton"
            onClick={onClose}
            text={i18n._('Cancel', 'cancel form')}
          />
          <LegacyButton
            className="blockButton"
            htmlType="submit"
            id="submitButton"
            loading={isLoading}
            onClick={onSubmit}
            text={i18n._('Block', 'submit form to block users')}
            type="primary"
          />
        </div>
      </div>
    </form>
  );
}

UserBlock.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      full_name: PropTypes.string.isRequired,
    }),
  ),
};

export default UserBlock;
